<template>
    <div class="practitioner-create mb-3 mt-page">

        <data-form :title="$i18n.gt('HEADING_CREATE_PRACTITIONER')"
                   :save-button-label="$i18n.gt('LABEL_SAVE')"
                   :field-model="practitionerFields"
                   :field-groups="fieldGroups"
                   :load-model-instance="loadModelInstance"
                   :on-submit-handler="onSubmit"
                   :submit-success-message="$i18n.gt('LABEL_PRACTITIONER_CREATED')"
                   :submit-error-message="$i18n.gt('LABEL_ERROR_CREATING_PRACTITIONER')"
                   :submit-success-route="successRoute"
                   :cancel-route="successRoute">
        </data-form>

    </div>
</template>

<script>

import Vue from 'vue'
import PractitionerFields from '@/models/Practitioner'

/**
 * Page to create a Practitioner for a Practice - either by an admin or by a practice manager/practitioner
 */
export default Vue.extend({
    name: "PractitionerCreate",
    props: {
        // neither is set if user is a practice manager
        companyId: Number,
        practiceId: Number
    },
    data() {
        return {
            practitionerFields: PractitionerFields,
            fieldGroups: [
                ['email', 'firstname', 'lastname'],
                ['role', 'title', 'receive_appointment_alert', 'npi', 'practitioner_code_id', 'disabled'],
            ],
            practitioner: null
        }
    },
    computed: {
        successRoute() {
            if (this.$user.roleIsAdmin()) {
                return `/practitioner/admin/companyId/${this.companyId}/practiceId/${this.practiceId}`
            } else {
                return '/practice/practitionerAdmin'
            }
        },
    },
    methods: {
        loadModelInstance() {
            return new Promise((resolve, reject) => {
                const practitioner = {
                    // this.practiceId is not set if user is a practice manager
                    practice_id: this.practiceId ? this.practiceId : this.$user.practitionerPracticeId()
                }
                this.practitioner = practitioner
                resolve(practitioner)
            })
        },
        onSubmit(modelInstance) {
            return this.$api.createItem(this, 'practitioner', modelInstance)
        }
    }
})

</script>
